export enum AgreementLevel {    
    StronglyDisagree = 0,
    Disagree = 1,
    MaybeALittle = 2,
    Agree = 3,
    StronglyAgree = 4
}